import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-cycle-time-breakdown-report.issue-table.title',
		defaultMessage: 'Issues shipped',
		description: 'Title of Issues shipped table',
	},
	noReviewTime: {
		id: 'software-cycle-time-breakdown-report.issue-table.no-review-time',
		defaultMessage: 'Review times unavailable',
		description:
			'Tooltip message explaining review times are unavailable for this particular issue',
	},
	headerCycleTime: {
		id: 'software-cycle-time-breakdown-report.issue-table.header-cycle-time',
		defaultMessage: 'Cycle time',
		description:
			'Cycle time of the development defined as from first commit to production deployment - Table column header',
	},
	headerIssue: {
		id: 'software-cycle-time-breakdown-report.issue-table.header-issue',
		defaultMessage: 'Issue',
		description: 'Jira issue - Table column header',
	},
	headerCommits: {
		id: 'software-cycle-time-breakdown-report.issue-table.header-commits',
		defaultMessage: 'Commits',
		description: 'Git commits - Table column header',
	},
	headerPullRequests: {
		id: 'software-cycle-time-breakdown-report.issue-table.header-pull-requests',
		defaultMessage: 'Pull requests',
		description: 'Pull requests of the source code - Table column header',
	},
	headerReviewTime: {
		id: 'software-cycle-time-breakdown-report.issue-table.header-review-time',
		defaultMessage: 'Review time',
		description: 'Text providing a quick overview of the purpose of the reports page',
	},
	headerDateDeployed: {
		id: 'software-cycle-time-breakdown-report.issue-table.header-date-deployed',
		defaultMessage: 'Date deployed',
		description: 'Build of source code - Table column header',
	},
});
